import React, {useContext, useEffect, useState} from "react";
import {directusContext} from "../../../app/DirectusProvider";
import EnfantCoursButton from "./EnfantCoursButton";
import DefaultGrid from "../../common/DefaultGrid";
import Roles from "../../../app/config/Roles";
import Title from "../../common/Title";
import moment from "moment";
import {loadSpinner} from "../../../utils/helpers";
import {motion} from "framer-motion"


const EnfantCoursList = ({coursId, historique}) => {
    const {directus, currentUser, version} = useContext(directusContext);
    const [enfantCours, setEnfantCours] = useState([]);

    useEffect(() => {
        if(coursId) {
            //TODO Suivre le développement de Directus pour voir si le problème de filtre et fuseau horraire est réglé
            const now = moment().format("Y-MM-DD");
            const filter = historique !== true ?
                {cours_id: {id: {_eq: coursId - 0}}} :
                {cours_id: {'date': historique ? {'_lt': now} : {'_gte': now}}};
            loadSpinner(
                new Promise((resolve, reject) => {
                    directus.items("cours_enfant").readByQuery({
                        fields: ['id', 'presence', 'enfant_id.nom', 'enfant_id.prenom', 'enfant_id.bus', 'enfant_id.naissance', 'cours_id.date', 'cours_id.groupe.nom'],
                        sort: ["enfant_id.prenom"],
                        filter: filter
                    }).then((resp) => {
                        setEnfantCours(resp.data.sort((a, b) => {
                            return a.enfant_id.prenom - b.enfant_id.prenom;
                        }));
                    }).catch(() => {
                        reject("Une erreur est survenue");
                    }).finally(() => {
                        resolve();
                    });
                })
            );
        }
    }, [coursId, currentUser, directus, historique, version]);

    return (
        <>
            {currentUser.role.name === Roles.parent && <Title title="Liste des cours"/>}
            <DefaultGrid>
                {enfantCours.map((ec, idx) => {
                    return (
                        <motion.div initial={{opacity: 0, y: -15}} animate={{opacity: 1, y: 0}} transition={{duration: 0.25, delay: 0.1 * idx}} key={`cours-enfant-list-item-${idx}`}>
                            <EnfantCoursButton enfantCours={ec} />
                        </motion.div>
                    );
                })}
            </DefaultGrid>
        </>

    );
};

export default EnfantCoursList;
